import { createAgWorksLrpEndorsementRequestBodySchema } from '@harvestiq/external-clients-agworks-common';
import { z } from '@harvestiq/zod';
import { AipIds } from '@harvestiq/constants';

const submitAgWorksLrpEndorsementReqSchema = z.object({
  endorsementRequest: createAgWorksLrpEndorsementRequestBodySchema,
});

export const submitAgWorksLrpEndorsementMsgSchema = z.object({
  // iiq
  orgId: z.string(),
  aipId: z.nativeEnum(AipIds),
  endorsementId: z.string().uuid(),

  // agworks
  request: submitAgWorksLrpEndorsementReqSchema,
});

export type SubmitAgWorksLrpEndorsementMsg = z.infer<
  typeof submitAgWorksLrpEndorsementMsgSchema
>;
